import { apiSlice } from "../../app/api/apiSlice";


export const updateFieldValuesTpoApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		updateFieldValuesTpo: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/upload_field_values/tpo_x4/",
				method: "POST",
				body: {
					loan_guid: credentials?.loan_guid,
					field_values: credentials?.field_values,
				},
				
			}),
		}),
	}),
});

export const { useUpdateFieldValuesTpoMutation } = updateFieldValuesTpoApiSlice;
